import {
	apiConf,
	sendRequest, ppAxios
} from '../config'

/**
 * 得到风险订单列表
 */
export const getRiskTranscationList = (param) => {
	return sendRequest(apiConf.riskApi.getRiskTranscationList, param)
}


/**
 *  黑名单列表查询
 */
export const blackWhiteList = (params) => {
	return sendRequest(["POST", "/merchant/acquirer/blackWhiteList/list"], params)
}

/**
 *  新增黑名单
 */
export const addName = (params) => {
	return sendRequest(["POST", "/merchant/acquirer/blackWhiteList/add"], params)
}


/**
 *  编辑黑名单
 */
export const editName = (id, params) => {
	return sendRequest(["POST", `/merchant/acquirer/blackWhiteList/edit/${id}`], params)
}


/**
 *  批量导入黑名单
 */
export const batchImport = (params) => {
	return sendRequest(["POST", "/merchant/acquirer/blackWhiteList/batchImport"], params)
}


/**
 *  枚举
 */
export const dictionary = (params) => {
	return sendRequest(["POST", "/merchant/dictionary"], params)
}

// 下载黑名单模板
export const downloadTemplate = (params) => {
	return ppAxios(
		['GET', '/merchant/acquirer/blackWhiteList/downloadTemplate'],
		params,
		{
			responseType: 'blob',
		}
	)
}

// 下载白名单模板
export const blackWhiteListDownloadTemplate = (params) => {
	return ppAxios(
		['GET', '/merchant/acquirer/blackWhiteList/downloadTemplate/white'],
		params,
		{
			responseType: 'blob',
		}
	)
}

/**
 *  生效、失效黑名单
 */
export const batchEdit = (params) => {
	return sendRequest(["POST", "/merchant/acquirer/blackWhiteList/batchEdit"], params)
}


/**
 *  删除黑白名单
 */
export const batchDelete = (params) => {
	return sendRequest(["POST", "/merchant/acquirer/blackWhiteList/batchDelete"], params)
}

/**
 *  Dispute 列表查询
 */
export const queryDisputePage = (params) => {
	return sendRequest(["POST", "/merchant/cbDispute/queryDisputePage"], params)
}

/**
 *  Dispute 详情
 */
export const queryDisputeDetail = (params) => {
	return sendRequest(["POST", "/merchant/cbDispute/queryDisputeDetail"], params)
}

/**
 *  Dispute 更新
 */
export const updateDisputeStatus = (params) => {
	return sendRequest(["POST", "/merchant/cbDispute/updateDisputeStatus"], params)
}

/**
 * Dispute 导出
 */
export const exportXLS = (params) => {
  return ppAxios(["POST", "/merchant/cbDispute/downloadDispute"], params, {
		responseType: 'blob'
	});
};

